export default __webpack_public_path__ + "static/media/air-ind.25feae87.jpg";